// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"12": "517313d4","366": "9154912f","654": "48e81ee6","985": "482cb750",}[chunkId] + ".css"
}